import { KdsInfoIcon, KdsText } from "@kazaar-platform/design-system";
import { RiCheckboxCircleFill } from "@remixicon/react";
import { useTranslate } from "@tolgee/react";

import { type OrderItemPageActivityLogAssignmentProductProps } from "./OrderItemPageActivityLogAssignmentProduct.types";

export const OrderItemPageActivityLogAssignmentProduct = ({
  assignedProductName,
}: OrderItemPageActivityLogAssignmentProductProps) => {
  const { t } = useTranslate();

  return (
    <div className="flex items-center gap-sp-xs2">
      <KdsText>
        {t(
          "order.myOrdersItemDetails.activityFeed.action.assignedProduct.intro",
          {
            assignedProductName,
          }
        )}
      </KdsText>

      <KdsInfoIcon
        icon={RiCheckboxCircleFill}
        state="success"
        label={t(
          "order.myOrdersItemDetails.activityFeed.action.infoIcon.added"
        )}
      />
    </div>
  );
};
